let req = require.context('@/assets/img/vehicle', true);

const vehicleObject = {
    ayla : req('./ayla.png'),
    gm_pu : req('./gm-pu.png'),
    gm_mb : req('./gm-mb.png'),
    gm_bv : req('./gm-bv.png'),
    himax : req('./himax.png'),
    luxio : req('./luxio.png'),
    sigra : req('./sigra.png'),
    sirion : req('./sirion.png'),
    terios : req('./terios.png'),
    xenia : req('./xenia.png'),
    "gran max pu" : req('./gm-pu.png'),
    "gran max mb" : req('./gm-mb.png'),
    "gran max bv" : req('./gm-bv.png'),
}

export default {
    //if search by type
    searchImageForCar : function(str){
        if(str == null)
            return null; 

        var str = str.toLowerCase();
        if(str.includes('gm') && str.includes('mb'))
            return vehicleObject.gm_mb;
        else if(str.includes('gm') && str.includes('bv'))
            return vehicleObject.gm_bv;
        else if(str.includes('gm') && str.includes('pu'))
            return vehicleObject.gm_pu;
        else{
            return vehicleObject[str];
        }
    },
    searchImageForCarByVariant : function(str){
        if(str == null)
            return null; 

        var str = str.toLowerCase();

        var keys = Object.keys(vehicleObject);

        for(var i = 0 ; i < keys.length; i++){
            if(str.includes(keys[i]))
                return vehicleObject[keys[i]]
        }
        return null;

    }
};
